import * as Yup from 'yup';
import { PhoneNumberUtil } from "google-libphonenumber";
const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

declare module 'yup' {
  export interface StringSchema {
    phone(message?: string): StringSchema;
  }
}

const YUP_PHONE_METHOD = 'phone';

Yup.addMethod<Yup.StringSchema<string>>(Yup.string, YUP_PHONE_METHOD, function yupPhone( message?: string ) {
  const errMsg = message || 'phone number is not valid.';
  return this.test(YUP_PHONE_METHOD, errMsg, (value: string) => {
      try{
        const parsedValue = phoneUtil.parse(value);
        if (!phoneUtil.isValidNumber(parsedValue)) {
          return false;
        }
        return true;    
      }catch(error){
          return false
      }
  });
});
